import clsx from "clsx";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import {
  liveMapMobileSurfaceAtom,
  LiveMapMobileSurfaceEnum,
  TOOLTIP_DELAY_BUTTONS,
} from "@ryde/shared";
import { deepPurpleMui, greyMui } from "@ryde/theme";

import { LiveMapViewSwitchStyled } from "./view-switch.live-map.styled";

export const ViewSwitchLiveMap: FC = () => {
  const { t } = useTranslation();
  const [mobileSurface, setMobileSurface] = useRecoilState(
    liveMapMobileSurfaceAtom,
  );

  const switchSurface = useEvent((surface: LiveMapMobileSurfaceEnum) => {
    setMobileSurface(surface);
  });

  const isGridActive = mobileSurface === LiveMapMobileSurfaceEnum.Grid;
  const isMapActive = mobileSurface === LiveMapMobileSurfaceEnum.Map;

  const { gridIconColor, mapIconColor } = useMemo(() => {
    const colorActive = deepPurpleMui.A700;
    const colorInactive = greyMui._600;

    return {
      gridIconColor: isGridActive ? colorActive : colorInactive,
      mapIconColor: isMapActive ? colorActive : colorInactive,
    };
  }, [isGridActive, isMapActive]);

  return (
    <LiveMapViewSwitchStyled>
      <FramerTooltip
        content={t("ui.SWITCH_TO_GRID_BULK_ACTIONS")}
        mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
      >
        <button
          type="button"
          className={clsx("live-map-view-switch__option", {
            "is-active": isGridActive,
          })}
          data-e2e="live-map-switch-to-grid"
          onClick={() => switchSurface(LiveMapMobileSurfaceEnum.Grid)}
        >
          <SVG_MUI.TableViewSVG
            fill={gridIconColor}
            className="live-map-view-switch__icon"
          />
        </button>
      </FramerTooltip>
      <FramerTooltip
        content={t("ui.TOGGLE_MAP")}
        mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
      >
        <button
          type="button"
          className={clsx("live-map-view-switch__option", {
            "is-active": isMapActive,
          })}
          data-e2e="live-map-switch-to-map"
          onClick={() => switchSurface(LiveMapMobileSurfaceEnum.Map)}
        >
          <SVG_MUI.MapToggle4SVG
            fill={mapIconColor}
            className="live-map-view-switch__icon"
          />
        </button>
      </FramerTooltip>
    </LiveMapViewSwitchStyled>
  );
};
